import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { FiDownload, FiEdit, FiTrash2 } from "react-icons/fi";
import CreateDocumentModal from "../CreateDocumentModal";


export default function FilesTab() {
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const [files, setFiles] = useState([
    {
      id: 1,
      title: "Collier-Turner Proposal",
      owner: "Darlee Robertson",
      type: "Proposal",
      status: "Proposal",
      content: "Sample document content",
    },
  ]);

  // CREATE / EDIT SAVE
  const handleSave = (data) => {
    if (editData) {
      setFiles(files.map((f) => (f.id === data.id ? data : f)));
      setEditData(null);
    } else {
      setFiles([{ ...data, id: Date.now() }, ...files]);
    }
    setShowModal(false);
  };

  // DELETE
  const handleDelete = () => {
    setFiles(files.filter((f) => f.id !== deleteId));
    setDeleteId(null);
  };

  // DOWNLOAD
  const handleDownload = (file) => {
    const blob = new Blob([file.content], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${file.title}.txt`;
    link.click();
  };

  return (
    <>
      <style>{`
        .file-card {
          border: 1px solid #eee;
          border-radius: 8px;
          padding: 15px;
          margin-bottom: 12px;
        }

           .notes-wrapper{
  
              align-items: center;
          border: 1px solid #eee;
          padding: 10px;
          border-radius: 6px;
          background:#ffffff;

       }
        .file-header {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
        }

        .file-title {
          font-weight: 600;
        }

        .file-owner {
          font-size: 13px;
          color: #666;
        }

        .badge-type {
          background: #ffe4e6;
          color: #dc2626;
          padding: 3px 8px;
          border-radius: 6px;
          font-size: 12px;
        }

        .badge-status {
          background: #e0f2fe;
          color: #0284c7;
          padding: 3px 8px;
          border-radius: 6px;
          font-size: 12px;
        }

        .create-btn {
          background: #ff6a00;
          color: #fff;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
        }

        @media(max-width:768px){
          .file-header{
            flex-direction: column;
            gap: 10px;
          }
        }
      `}</style>

      {/* HEADER */}
      <div className="d-flex justify-content-between p-3 notes-wrapper">
        <h5>Files</h5>
        <button className="create-btn" onClick={() => setShowModal(true)}>
          Create Document
        </button>
      </div>

      {/* LIST */}
      <div className="p-3">
        {files.map((file) => (
          <div className="file-card" key={file.id}>
            <div className="file-header">
              <div>
                <div className="file-title">{file.title}</div>
                <div className="file-owner">
                  Owner: {file.owner}
                </div>
              </div>

              <div className="d-flex gap-2 align-items-center">
                <span className="badge-type">{file.type}</span>
                <span className="badge-status">{file.status}</span>

                <FiDownload
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDownload(file)}
                />
                <FiEdit
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setEditData(file);
                    setShowModal(true);
                  }}
                />
                <FiTrash2
                  style={{ cursor: "pointer" }}
                  onClick={() => setDeleteId(file.id)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* CREATE / EDIT MODAL */}
      <CreateDocumentModal
        show={showModal}
        handleClose={() => {
          setShowModal(false);
          setEditData(null);
        }}
        handleSave={handleSave}
        editData={editData}
      />

      {/* DELETE MODAL */}
      {deleteId && (
        <div className="modal-backdrop">
          <div className="modal-box">
            <h6>Are you sure?</h6>
            <button onClick={handleDelete}>Delete</button>
            <button onClick={() => setDeleteId(null)}>Cancel</button>
          </div>
        </div>
      )}
    </>
  );
}